import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { createCardsSectionInstance } from '../../Models/CardsSection';
import './CardsSection.css';

const CardsSection = (props) => {
    const [cardsSection, setCardsSection] = useState(createCardsSectionInstance());
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const inst = createCardsSectionInstance();
                await inst.load(props.id);
                inst.renderStyles();
                setCardsSection(inst);
                setIsLoading(false);
            } catch (err) {
                console.error('Failed to load cards section:', err);
                setError('Failed to load cards section');
                setIsLoading(false);
            }
        };
        fetchData();
    }, [props.id]);

    if (isLoading) {
        return <div className="loading-placeholder">Loading cards section...</div>;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    const sectionId = cardsSection.getId();
    const sectionTitle = cardsSection.getSectionTitle();
    const cards = cardsSection.getCards();
    const cardsLayout = cardsSection.getCardsLayout();

    return (
        <section className={`CardsSection CardsSection-${sectionId}`}>
            <Container className="CardsSection-inner">
                {sectionTitle?.trim() && (
                    <h2 className={`CardsSectionTitle CardsSectionTitle-${sectionId}`}>
                        {sectionTitle}
                    </h2>
                )}
                <div className={`CardsSection-grid CardsSection-grid--${cardsLayout}`}>
                    {cards.map((card) => {
                        const effective = cardsSection.getCardEffectiveStyle(card);
                        const titleClass = card.useCustomStyle
                            ? `CardsSection-card-title CardsSectionCardTitle-${sectionId}-${card.id}`
                            : `CardsSection-card-title CardsSectionCardGlobal-${sectionId}`;
                        const descClass = card.useCustomStyle
                            ? `CardsSection-card-description CardsSectionCardDesc-${sectionId}-${card.id}`
                            : `CardsSection-card-description CardsSectionCardGlobalDesc-${sectionId}`;
                        const radiusClass =
                            effective.borderRadius === 'normal'
                                ? 'CardsSection-card--normal'
                                : 'CardsSection-card--rounded';
                        const layoutClass =
                            effective.imageStyle === 'fill' ? 'CardsSection-card--fill' : '';
                        const textAlignClass =
                            effective.textAlign === 'justified'
                                ? 'CardsSection-card-body--justified'
                                : 'CardsSection-card-body--center';
                        const hasCardBgImage = !!effective.backgroundImage;
                        const cardSurfaceClass = card.useCustomStyle
                            ? `CardsSectionCardBg-${sectionId}-${card.id}`
                            : `CardsSectionCardBgGlobal-${sectionId}`;

                        return (
                            <article
                                key={card.id}
                                className={`CardsSection-card ${radiusClass} ${layoutClass} ${cardSurfaceClass} ${hasCardBgImage ? 'CardsSection-card--has-bg' : ''}`}
                            >
                                {card.imageUrl && effective.imageStyle === 'fill' && (
                                    <div className="CardsSection-card-image-wrap--fill">
                                        <img
                                            src={card.imageUrl}
                                            alt={card.title || ''}
                                            className="CardsSection-card-image--fill"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                                <div className={`CardsSection-card-body ${textAlignClass}`}>
                                    {card.imageUrl && effective.imageStyle === 'circle' && (
                                        <div className="CardsSection-card-image-wrap--circle">
                                            <img
                                                src={card.imageUrl}
                                                alt={card.title || ''}
                                                className="CardsSection-card-image--circle"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                    )}
                                    {card.title?.trim() && (
                                        <h3 className={titleClass}>{card.title}</h3>
                                    )}
                                    {card.description?.trim() && (
                                        <p className={descClass}>{card.description}</p>
                                    )}
                                </div>
                            </article>
                        );
                    })}
                </div>
            </Container>
        </section>
    );
};

export default CardsSection;
